<template>
  <footer class="footer">
    <div class="footer-inner">
      <a href="https://www.symbiocenter.com/assets/Mentions_legales.pdf" target="_blank" class="footer-link">
        Mentions légales
      </a>
      <a href="https://www.symbiofi.com" target="_blank" class="footer-link">
        Centre de formation
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #2c2c2c;
  padding: 24px 20px;
  margin-top: auto;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
}

.footer-link {
  color: #ccc;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s;
}

.footer-link:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

/* Responsive */
@media (max-width: 480px) {
  .footer-inner {
    flex-direction: column;
    gap: 16px;
  }
  
  .footer-link {
    padding: 12px 20px;
  }
}
</style>